export const headerSection = {
  benefits: 'Benefits',
  partners: 'Partners',
  setups: 'Setups',
};

export const description = 'The sun is our main source of energy and life on Earth. Fossil fuels were once created from their energy, but now we are using them up so fast that we will soon run out of them. The exploitation of solar energy is the first step towards environmental awareness. And we are happy to be able to accompany you on this journey.'